import { Typography } from '@mui/material';
import React from 'react';
import { jbColors } from 'theme/jbColors';

const CardHeaderComponent = ({ title }: { title: React.ReactNode }) => {
  return (
    <Typography
      data-testid="card-header"
      sx={{
        color: jbColors.core.reflexBlue[100],
        fontWeight: 'bold',
        marginBottom: '1em',
      }}
    >
      {title}
    </Typography>
  );
};

export default CardHeaderComponent;
